import { useCustomToast } from '@elkaso-app/web-design';
import http from 'apis/config/http-service';
import { useMutationWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import type { UseMutationOptions, UseMutationResult } from 'react-query';
import { DeleteReconciliationDocumentPayload, ReconciliationSupplierDetail } from './types';

const getEndpoint = (supplierId: number, documentId: number) =>
  `ums/v1/cms/reconciliation/suppliers/${supplierId}/documents/${documentId}`;

type TData = ReconciliationSupplierDetail;
type TError = AxiosError;
type TVariables = DeleteReconciliationDocumentPayload;
type Options = Omit<UseMutationOptions<TData, TError, TVariables, unknown>, 'mutationFn'>;
type ReturnType = UseMutationResult<TData, TError, TVariables>;

export function useDeleteReconciliationDocumentApi(options?: Options): ReturnType {
  const toast = useCustomToast();

  const mutationFn = async ({ month, supplierId, documentId }: TVariables) => {
    try {
      const { data } = await http.delete(getEndpoint(supplierId, documentId), { params: { month } });
      return data;
    } catch (error: any) {
      if (!error.response?.status) throw error;

      toast({
        description: error.response?.data?.message ?? 'Failed to delete the statement document',
        status: 'error',
      });

      throw error;
    }
  };

  return useMutationWrapper(mutationFn, {
    ...options,
    mutationKey: ['reconciliation-delete-document'],
  });
}
